// extracted by mini-css-extract-plugin
module.exports = {"root":"BarcBanner_root__MM95g","iconImage":"BarcBanner_iconImage__ZN5NC","text":"BarcBanner_text__W8DAm","earn":"BarcBanner_earn__6UGIP","chevron":"BarcBanner_chevron__9B_VC"};